import * as React from 'react';
import { translate } from 'react-i18next';
import * as css from './TeamDetails.scss';

import { Text, Avatar, Button, Heading } from 'wix-style-react';

export const TeamCount: any = translate()(({ t, usersLength, invitesLength }) => {
  return (
    <Text dataHook="members-count-text" size="medium" light secondary tagName="span" weight="thin">
      {usersLength} {t('teamDetails.joined')}
      {!!invitesLength && `, ${invitesLength} ${t('teamDetails.invited')}`}
    </Text>);
});

export const ModalButton: any = translate()(({ t, onClick }) => {
  return (
    <Button dataHook="team-details-modal-button" priority="secondary"  as="button" size="small" onClick={onClick}>
      {t('teamDetails.editNameAndLogo')}
    </Button>);
});

export const TeamName: any = translate()(({ t, name }) => {

  return (
    <Heading appearance="H3" dataHook="team-details-title">
      <div className={name ? '' : css.unnamedTeam}>
        {name ? name : t('teamDetails.unnamedTeam')}
      </div>
    </Heading>
  );
});

export const TeamImage: any = ({ imageUrl }) => {
  return (
    <div className={css.image}>
      {imageUrl && <img height="60" width="60" data-hook="team-image-url" src={imageUrl}/>}
      {!imageUrl && <Avatar dataHook="empty-team-image" shape="square" size="size60"/>}
    </div>
  );
};
